import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchLogs } from '../../features/dashboard/DocumentLogSlice';
import Header from './Header';
import Input from '../form/Input';
import Select from '../form/Select';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';
import { Calendar } from "react-multi-date-picker";
import DatePicker,{DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import * as moment from 'jalali-moment';

function DocumentLog () {

    const dispatch = useDispatch();
    const [status, setStatus] = useState(false)
    const [documentNumber, setDocumentNumber] = useState('')
    // const [loading, setLoading] = useState(true)
    let {
        loading,
        success,
        flag,
        message,
        loglist,
        errorDocumentNumber,
    } = useSelector((state) => state.documentLog)

    useEffect(() => {
        console.log(errorDocumentNumber)
        // Handle Loading page Before Load DOM
        // status === true ? setLoading(true) : setLoading(false)
        // dispatch(documentLogs(documentLogs.getItem('token')));
        if(success === true && status === true) {
            toast.success(message,{
                position: "top-center",
                autoClose: 600,
              })
            setStatus(false)
            setDocumentNumber('')
            message = ''
        }
        // if(success === false && loading === false) {
        //     toast.error(message,{
        //         position: "top-center",
        //         autoClose: 600,
        //       })
        // }

        return () => {
            // Handle Loading page Before Load DOM
            // setLoading(archiveSectionOneSuccess)
        }

    },[success])

    const documentSearchHandler = (event) => {
        event.preventDefault();
        // setLoading(true)
        setStatus(true)
        const data = {
            'documentNumber': documentNumber
        }
        dispatch(searchLogs(data));
    }
    return (
        <>
        { loading ? (<Loading />) : null }
        <form className="text-end">
            <div className='row g-2 p-5 my-5'>
                <Header title={'تراکنش های سند'} />  
                <div className="col-6 ">
                    <Input 
                        key='2'
                        tab='2'
                        col='col-12'
                        type='text'
                        maxlength={50}
                        name='documentNumber'
                        value={documentNumber}
                        title='شماره سند'
                        onchange={(e) => setDocumentNumber(e.target.value)}
                        placeholder='382100' 
                        errorName={errorDocumentNumber}
                    />   
                </div>
                <div className="row g-2 px-0 mt-4 mb-0">
                    <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                        <Button 
                            tab='3'
                            title='جستجو سند'
                            design="position-relative px-4 py-1 btn btn-dark fw-bold"
                            event={documentSearchHandler}
                        />
                    </div>
                </div>
                {
                    (message) ? (
                        <strong className='p-3 py-0'># {message}</strong>
                    ): null
                }
            </div>
        </form>
        {
            (loglist) ? (
                (Object.keys(loglist).length > 0 && flag === true) ? (
                    <div className='row g-2 p-5 my-5'>
                        <Header title={'تراکنش های سند'} />  
                        <div className='mt-3    row row-cols-3 justify-content-center text-center'>
                            <div className='col d-flex flex-column p-3 border'>
                                <h4>شماره بنده</h4>
                                <span>{loglist[0].mt_bodyno}</span>
                            </div>
                            <div className='col d-flex flex-column p-3 border'>
                                <h4>شماره بنده</h4>
                                <span>{loglist[0].mt_sanadno}</span>
                            </div>
                            <div className='col d-flex flex-column p-3 border'>
                                <h4>شماره پلاک</h4>
                                <span className='d-flex justify-content-center'>
                                    <span>{loglist[0].mt_pelakserial+'-'}</span>
                                    <span>{loglist[0].mt_pelakno}</span>
                                </span>
                            </div>
                        </div>
                        <div className='row'>
                            <table className='table striped'>
                                <thead>
                                    <tr className='table-dark'>
                                        <th className='text-center'>#</th>
                                        <th>کاربر</th>
                                        <th>توضیحات</th>
                                        <th>وضعیت</th>
                                        <th className='text-center'>تاریخ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    loglist[0].logs.map((log, key) => (
                                    <tr>
                                        <td className='text-center'>{++key}</td>
                                        <td>{log.userProfile.name}</td>
                                        <td>{log.title}</td>
                                        <td>{'-'}</td>
                                        <td className='text-center'>{moment(log.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</td>
                                    </tr>
                                    ))
                                }
                                </tbody>
                            </table>
                        </div>
                        
                    </div>
                ) : null
            ) : null

        }
        </>
    )
}

export default DocumentLog;